'use strict';
import "regenerator-runtime/runtime";
let React = require('react');
let BaseComponent = require('../../shared/base');
let client = require('../../../../sdk/client');

const sortTypes = {
    up: {
        class: 'sort-up'
    },
    down: {
        class: 'sort-down'
    },
    default: {
        class: 'sort'
    }

};
class OrderItemsTableComponent extends BaseComponent {

    constructor(props) {
        super(props)
        this.popupInvoice = React.createRef()

        this.state = {
            data: this.props.datatable,
            dataest: this.props.dataestafeta,
            currentSort: 'default',
        }
        this.onSortChange = this.onSortChange.bind(this)
    }

    componentDidMount() {

        this.setState({
            data: this.props.datatable,
            dataest: this.props.dataestafeta,
            currentSort: 'default'
        });
    }

    onSortChange(attribute) {
        //  console.log(this.state.currentSort)
        //  console.log(attribute)
        let nextSort;
        var datat = this.props.datatable;
        if (this.state.currentSort === 'down') {
            nextSort = 'up';
            datat = this.props.datatable.sort((a, b) => {
                if (a[attribute] < b[attribute]) return -1;
                if (a[attribute] > b[attribute]) return 1;
                return 0;
            });
        } else if (this.state.currentSort === 'up') {
            nextSort = 'down';
            datat = this.props.datatable.sort((a, b) => {
                if (a[attribute] > b[attribute]) return -1;
                if (a[attribute] < b[attribute]) return 1;
                return 0;
            });
        }
        else if (this.state.currentSort === 'default') {
            nextSort = 'up';
            datat = this.props.datatable.sort((a, b) => {
                if (a[attribute] < b[attribute]) return -1;
                if (a[attribute] > b[attribute]) return 1;
                return 0;
            });
        }
        //datat = request.sort(sortTypes[nextSort].fn)
        //  console.log(nextSort)
        //  console.log(datat)
        this.setState({
            currentSort: nextSort,
            data: datat
        });
    };

    renderHeaderTable() {

        if (typeof this.renderCustomHeader == 'function') return this.renderCustomHeader();
        return (
            <thead>
                <tr>
                    <th style={{ width: '145px', paddingRight: '10px' }}>Num. de parte<button className="btnsort" onClick={this.onSortChange.bind(this, "PartCode")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Descripción<button className="btnsort" onClick={this.onSortChange.bind(this, "PartDescription")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Precio<button className="btnsort" onClick={this.onSortChange.bind(this, "UnitPrice")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Pedido<button className="btnsort" onClick={this.onSortChange.bind(this, "OrderedQuantity")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Surtido<button className="btnsort" onClick={this.onSortChange.bind(this, "AssortedQuantity")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Subtotal<button className="btnsort" onClick={this.onSortChange.bind(this, "SubTotalAmount")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Precio CORE<button className="btnsort" onClick={this.onSortChange.bind(this, "UnitPriceCore")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                    <th>Subtotal CORE<button className="btnsort" onClick={this.onSortChange.bind(this, "SubTotalCoreAmount")}><i className={`fas fa-${sortTypes[this.state.currentSort].class}`} /></button></th>
                </tr>
            </thead>
        );
    }

    populateTableDetailSupplyOrder() {
        if (this.props.datatable.length) {
            var index = 0;
            return this.props.datatable.map(function (itemOrder) {
                return <tr key={itemOrder.PartCode}>
                    <td style={{ width: '145px' }}>{itemOrder.PartCode}</td>
                    <td>{itemOrder.PartDescription}</td>
                    <td>${itemOrder.UnitPrice}</td>
                    <td>{itemOrder.OrderedQuantity}</td>
                    <td>{itemOrder.AssortedQuantity}</td>
                    <td>${itemOrder.SubTotalAmount}</td>
                    <td>${itemOrder.UnitPriceCore}</td>
                    <td>${itemOrder.SubTotalCoreAmount}</td>
                </tr>;
            }, this);
        } else {
            return <tr>
                <td>No hay artículos</td>
                <td></td>
                <td></td>
                <td></td>
                <td>

                </td>
            </tr>;
        }
    }

    populateTableDetailOrderEstafeta() {
        if (this.props.dataestafeta.length) {
            return this.props.dataestafeta.map(function (itemOrder) {
                
                return <tbody className="bodytb-invoice">
                    <tr>
                        <th><label style={{ fontSize: '18px' }}> Estatus del envío: {itemOrder.status}</label></th>
                    </tr>
                    {itemOrder.waybillId != "" &&
                        <tr>
                            <th><label style={{ fontSize: '14px', fontWeight: 'normal' }}>Número de Guía:</label><label style={{ color: '#009edf', fontWeight: 'bold', textDecoration: 'underline #17A2B8' }}> {' ' + itemOrder.waybillId != "" ? itemOrder.waybillId : ''}</label></th>
                        </tr>
                    }

                    {this.populateRowHistory(itemOrder.History)}

                    </tbody>
            }, this)
        } else {
            <label>No existe información sobre el envío</label>
        }
    }



    populateRowHistory(arrHistory) {
        
        if (arrHistory.length) {
            let arrHistoryAux = arrHistory
            var typeHorarioA, typeHorarioB = "";
            // ordenando el array
            arrHistoryAux.sort(function (a, b) {
                typeHorarioA = a.eventDateTime.substring(a.eventDateTime.length - 4, a.eventDateTime.length);
                typeHorarioB = b.eventDateTime.substring(b.eventDateTime.length - 4, b.eventDateTime.length);
              
                if (a.eventDateTime < b.eventDateTime) {
                    if (typeHorarioA < typeHorarioB || typeHorarioA == typeHorarioB) {
                        return 1;
                    }
                     else {
                        return -1;
                    }
                }
                if (a.eventDateTime > b.eventDateTime) {
                    if (typeHorarioA < typeHorarioB ||  typeHorarioA == typeHorarioB) {
                        return -1;
                    } else {
                        return 1;
                    }
                }
                return 0;
            });          

            return arrHistory.map(function (history) {
                return <tr key={history.eventDateTime}>
                    <th>
                        <label style={{ fontSize: '16px', fontWeight: 'bold' }}>{history.eventDateTime}</label><br></br>
                        <label style={{ fontSize: '14px', fontWeight: 'normal' }}> {history.eventDescriptionSPA}</label><br></br>
                        <label style={{ fontSize: '14px', fontWeight: 'normal' }}>

                            {history.exceptionCodeDescriptionSPA != "" ?
                                history.exceptionCodeDescriptionSPA + ' | ' + history.eventPlaceName
                                : history.eventPlaceName
                            }

                        </label><br></br>
                    </th>
                </tr>;
            }, this)

        }
    }




    renderTablePopUp() {
        var classModal = "modalOrderID-general";
        return (<div className={"modal fade " + classModal} id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document" id="contentModalItemsOrder">
                <div className="modal-content modal-orderitemstable">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalCenterTitle">Desglose de artículos</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div id="invoiceTable" ref={this.popupInvoice} className="subaccount-data-table table-responsive" style={{ maxHeight: '400px' }}>

                            <table id="tabla-order-items" className="table-scroll table sub-account tb-left">
                                {this.renderHeaderTable()}
                                <tbody className="bodytb-invoice">
                                    {/*this.populateTable()*/}
                                    {this.populateTableDetailSupplyOrder()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        );
    }

    renderModalEstafeta() {
        var classModal = "modalShippingGuides-general";
        return (<div className={"modal fade " + classModal} id="modalEstafeta" tabindex="-1" role="dialog" aria-labelledby="modalEstafetaTitle" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document" id="contentModal">
                <div className="modal-content modal-orderitemstable">
                    <div className="modal-header">
                        <h4 className="modal-title" align="center" id="modalEstafetaTitle">Actualizaciones de envío</h4>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div id="tableEstafeta" ref={this.popupInvoice} className="subaccount-data-table table-responsive" style={{ maxHeight: '400px' }}>
                            <table id="tabla-est" className="table-scroll table sub-account tb-left">

                                {this.populateTableDetailOrderEstafeta()}

                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        );
    }

    render() {
        return (
            <React.Fragment>
                {/*<button type="button" className="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
                Ver modal
                </button>*/}
                {this.renderTablePopUp()}
                {this.renderModalEstafeta()}
            </React.Fragment>
        );
    }
}

module.exports = OrderItemsTableComponent;